/** internal */
import React from "react";
import { WarningTriangleFilled } from "@toddle-edu/ds-icons";
import classNames from "classnames";
/** relative */
import classes from "./FieldErrorMessage.scss";

const FieldErrorMessage = props => {
  const { t } = props;

  const errorTextClasses = classNames(classes.errorText, "text-body-3");

  return (
    <div className={classes.errorContainer}>
      <WarningTriangleFilled variant="critical" size="xxx-small" />
      <span className={errorTextClasses}>{t("worksheet:required_field")}</span>
    </div>
  );
};

export default FieldErrorMessage;
